/* eslint-disable max-len */

// #region Imports

import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import getCurrentTime from 'utils';
import { ASSESSMENTS } from 'config/constants';
import { BlockCell, DebugPanel } from './components';

// #endregion Imports

// #region Component

function BlockMemoryGrid({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  resultsCallback = () => {},
  activeItems = {},
  flashcard,
  answers,
  trial = 0,
  submitResults = false,
  displayResult = false,
  complete = false,
  debug = false,
}) {
  if (flashcard) {
    const delay = ASSESSMENTS.FLASH_CARD_INTERVAL;
    setTimeout(resultsCallback, delay);
  }

  // #region Hooks

  const [startTime, setStartTime] = useState(0);
  const [clickTracker, setClickTracker] = useState([]);
  const [selections, setSelections] = useState([]); // eslint-disable-line
  const [content, setContent] = useState({});
  const [answered, setAnswered] = useState(false);
  const [correctAnswers, setCorrectAnswers] = useState(0);

  useEffect(() => {
    setStartTime(getCurrentTime());
  }, []);

  useEffect(() => {
    const newContent = {};

    if (selections.length > 0) {
      for (let index = 0; index < selections.length; index += 1) {
        newContent[selections[index]] = index + 1;
      }
    }

    setContent(newContent);
  }, [selections]);

  // #endregion Hooks

  // #region utility

  const recordClickEvent = (event) => {
    const clickEvent = { id: event, time: getCurrentTime() };
    setClickTracker((oldArr) => [...oldArr, clickEvent]);
  };

  const buildResults = () => ({
    startTime,
    userClicks: clickTracker,
    userSelections: content,
    trial,
    submitResults,
    complete,
    endTime: getCurrentTime(),
  });

  // #endregion utility

  // #region Event Handlers

  const handleGridClick = async (id) => {
    if (!flashcard) {
      recordClickEvent(`${id}`);
      const index = selections.findIndex((val) => val === id);

      if (index === -1) {
        await setSelections((oldArr) => [...oldArr, id]);
      } else {
        await setSelections((oldArr) => [...oldArr.filter((_, i) => i !== index)]);
      }
    }
  };

  const handleClearClick = async (event) => {
    event.target.blur();
    await recordClickEvent('clear');
    await setSelections([]);
  };

  const handleSubmit = (event) => {
    event.target.blur();
    const result = buildResults();
    setAnswered(true);
    if (selections.length > 0) {
      setCorrectAnswers(0);
      let answeredCorrectly = 0;
      for (let a = 0; a < answers.length; a += 1) {
        const answer = result.userSelections[answers[a].cell];
        if (answer && answer === answers[a].index) {
          answeredCorrectly += 1;
        }
        setCorrectAnswers(answeredCorrectly);
      }
    }
    if (displayResult) {
      const timer = setInterval(() => {
        clearTimeout(timer);
        resultsCallback(result);
      }, 2000);
    } else {
      resultsCallback(result);
    }
  };

  // #endregion Event Handlers

  // #region Render

  return (
    <div className="user-select-none d-flex flex-column justify-content-center m-3">
      <div className="user-select-none d-flex flex-column justify-content-center m-3">
        <div className="row  justify-content-center">
          <BlockCell cellId={1} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={2} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={3} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={4} onClick={handleGridClick} isActive={activeItems} content={content} />
        </div>
        <div className="row justify-content-center">
          <BlockCell cellId={5} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={6} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={7} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={8} onClick={handleGridClick} isActive={activeItems} content={content} />
        </div>
        <div className="row justify-content-center">
          <BlockCell cellId={9} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={10} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={11} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={12} onClick={handleGridClick} isActive={activeItems} content={content} />
        </div>
        <div className="row justify-content-center">
          <BlockCell cellId={13} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={14} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={15} onClick={handleGridClick} isActive={activeItems} content={content} />
          <BlockCell cellId={16} onClick={handleGridClick} isActive={activeItems} content={content} />
        </div>
      </div>
      {!flashcard && !answered && (
        <div className="d-flex justify-content-center my-3">
          <Button className="btn-assessment-secondary mx-1" onClick={(event) => handleClearClick(event)}>
            Clear
          </Button>
          <Button className="btn-assessment-primary mx-1" onClick={(event) => handleSubmit(event)}>
            Submit
          </Button>
        </div>
      )}
      {displayResult && answered && (
        <div className="d-flex justify-content-center mb-4">
          {`You reported ${correctAnswers} out of ${answers.length} locations correctly.`}
        </div>
      )}
      {debug && (
        <div className="h-25 overflow-auto border border-dark rounded-2 bg-light p-3">
          <DebugPanel startTime={startTime} clickTracker={clickTracker} />
        </div>
      )}
    </div>
  );

  // #endregion End Render
}

// #endregion Component

export default BlockMemoryGrid;
